import {components} from "react-select";
import React, {Fragment} from "react";

const Menu = props => {
    return (
        <Fragment>
            <components.Menu {...props}  className={props.selectProps.arrowAutoPlacement(props.menuPlacement, props.placement)}>
                <div className="filter-wrapper">
                    <div className="filter-list">
                        {props.children}
                    </div>
                </div>
            </components.Menu>
        </Fragment>
    );
};

export default Menu;